export default "__VITE_ASSET__BJhyjs4R__"